import Layout from "../components/Layout";
import React, {useEffect, useState, useRef} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {Formik } from 'formik'
import TextField from "../components/TextField";
import axios from 'axios';
import {BASE_URL} from "../utils/commonUrl";
import {ProgressSpinner} from "primereact/progressspinner";
import * as Yup from "yup";
import { Toast } from 'primereact/toast';

const EmployeeInsert = () => {
    const primeToast = useRef(null)
    const {user} = useSelector((state) => state["auth"]);
    const [isLoading,setIsLoading] = useState(false)
    const [isEnable,setIsEnable] = useState(true)
    const [isRemove,setIsRemove] = useState(false)
    const [isActivateEmployee,setIsActivateEmployee] = useState(false)
    const [userInformation, setUserInformation] = useState({
        //EmployeeCode,EmployeeName,Department,Designation,DOB,DOJ,Section
        registerID: null,
        factoryID: "",
        employeeCode: "",
        employeeName: "",
        department:"",
        designation:"",
        dob:"",
        doj:"",
        section:"",
        title:"",
        employeeStatus:""
    })
    useEffect(() => {
        //console.log(isEnable);
    }, [isEnable,isRemove])

    const GetUserInformation=()=>{
        setIsLoading(true);
        const _FactoryID = document.getElementById("ddlFactory").value
        const _EmployeeCode = document.getElementById("txtEmployeeCode").value
        const data = {
            FactoryID: _FactoryID,
            EmployeeCode: _EmployeeCode
        }

        axios.post(BASE_URL + "/api/register/CheckEmployeeExists", JSON.stringify(data))
            .then(response => {
                if(response.data.length > 0){
                        setUserInformation({
                            registerID: user.registerID,
                            factoryID: _FactoryID,
                            employeeCode:response.data[0].employeeCode,
                            employeeName:response.data[0].employeeName,
                            department:response.data[0].department,
                            designation:response.data[0].designation,
                            dob:response.data[0].dob,
                            doj:response.data[0].doj,
                            section:response.data[0].section,
                            title:response.data[0].title,
                            employeeStatus:response.data[0].employeeStatus,
                    });
                    
                    if(response.data[0].title==="New"){
                        setIsEnable(false);
                        setIsRemove(false);
                        setIsActivateEmployee(false);
                    }
                    else{                        
                        primeToast.current.show({
                            severity: 'info',
                            summary: 'Warning',
                            detail: 'Selected Employee Already Assigned in PMS..!',
                            life: 3000
                        });

                        if(response.data[0].employeeStatus==="Active"){
                            setIsRemove(true);
                            setIsActivateEmployee(false);
                        }
                        else if(response.data[0].employeeStatus==="InActive"){
                            setIsActivateEmployee(true);
                            setIsRemove(false);
                        }
                        setIsEnable(true);
                        
                    }
                }
                else{
                    setUserInformation({
                        registerID: null,
                        factoryID: "",
                        employeeCode: "",
                        employeeName: "",
                        department:"",
                        designation:"",
                        dob:"",
                        doj:"",
                        section:"",
                        title:"",
                        employeeStatus:""
                    });

                    setIsRemove(true);
                    setIsEnable(true);
                    setIsActivateEmployee(true);

                    primeToast.current.show({
                        severity: 'error',
                        summary: 'error',
                        detail: 'Selected Employee Not Found..!',
                        life: 3000
                    });
                }
                setIsLoading(false);
            })
            .catch(e => {
                setIsLoading(false);
                console.log(e)
            })
    }
    const ResetEmpList = ()=>{
        setUserInformation({
            registerID: null,
            factoryID: "",
            employeeCode: "",
            employeeName: "",
            department:"",
            designation:"",
            dob:"",
            doj:"",
            section:"",
            title:"",
            employeeStatus:"",
        });
        setIsEnable(true);
        setIsRemove(false);
        document.getElementById("txtEmployeeCode").value="";
    }    
    
    const DeactiveUser = (e)=>{
        e.preventDefault();
        setIsLoading(true);
        const data = {
            registerID: user.registerID,
            FactoryID: userInformation.factoryID,
            EmployeeCode: userInformation.employeeCode
        }
       const _answer =  window.confirm("Are you sure?");

       if(_answer){
        axios.post(BASE_URL + "/api/register/DeactivateEmployee", JSON.stringify(data))
        .then(response => {
            if(response.status === 200){
                primeToast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Selected Employee Deactivated Successfully..!',
                    life: 3000
                });  
                setIsEnable(true);
                setIsRemove(false);
                GetUserInformation();
            }
            else{                
                setIsRemove(true);
                setIsEnable(true);
                primeToast.current.show({
                    severity: 'error',
                    summary: 'error',
                    detail: 'Selected Employee Deactivated Failed..!',
                    life: 3000
                });
            }
            setIsLoading(false);
        })
        .catch(e => {
            console.log(e);
            setIsLoading(false);
        })
       }
    }

    const ActivateUser = (e)=>{
        e.preventDefault();
        setIsLoading(true);
        const data = {
            registerID: user.registerID,
            FactoryID: userInformation.factoryID,
            EmployeeCode: userInformation.employeeCode
        }
       const _answer =  window.confirm("Are you sure?");

       if(_answer){
        axios.post(BASE_URL + "/api/register/ActivateEmployee", JSON.stringify(data))
        .then(response => {
            if(response.status === 200){
                primeToast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Selected Employee Activated Successfully..!',
                    life: 3000
                });  
                setIsEnable(true);
                setIsRemove(false);
                GetUserInformation();
            }
            else{                
                setIsRemove(true);
                setIsEnable(true);
                primeToast.current.show({
                    severity: 'error',
                    summary: 'error',
                    detail: 'Selected Employee Activated Failed..!',
                    life: 3000
                });
            }
            setIsLoading(false);
        })
        .catch(e => {
            setIsLoading(false);
            console.log(e);
        })
       }
    }
    return (<Layout>
        <Toast ref={primeToast}/>
        <div className="card mt-2">
            <div className="card-header d-flex justify-content-between">
                <h6><i class="bi bi-person-plus"></i> Insert Employee Information</h6>
            </div>            
            <div className="card-body">
                <div className="row">
                    <div className="col-3">
                        <select id="ddlFactory" className="form-control" onChange={ResetEmpList}>
                            <option value="-1">-- Select Factory --</option>
                            <option value="02">Corporate</option>
                            <option value="04">BGL</option>                            
                            <option value="09">RHL</option>
                            <option value="06">TAL</option>
                        </select>
                    </div>
                    <div className="col-3">
                        <input type="text" name="txtEmployeeCode" id="txtEmployeeCode" className="form-control" placeholder="Enter Employee Code.." />
                    </div>
                    <div className="col-3">
                        <button type="submit" className="btn btn-info" onClick={GetUserInformation}><i class="bi bi-arrow-down-circle-fill"></i> Search</button>
                    </div>
                    <div className="col-1">
                        {isLoading ? <ProgressSpinner style={ {height:50,width:50} }/> : ""}
                    </div>
                    <div className="col-2" style={{paddingTop:"10px"}}>
                    {   userInformation.employeeStatus === "" ? "" :
                          <span style={{backgroundColor:"#4a0e93",padding:"10px", color:"#fff",fontWeight:"600", borderRadius:"3px"}}>{userInformation.employeeStatus}</span>
                     }    
                    </div>
                </div>
                <hr></hr>
            {/* validationSchema={validation} */}
            <Formik  
        enableReinitialize={true} 
       initialValues={{ registerID:user.registerID, 
        factoryID: userInformation.factoryID===""?"":userInformation.factoryID,
        employeeCode: userInformation.employeeCode===""?"":userInformation.employeeCode,
        employeeName: userInformation.employeeName===""?"":userInformation.employeeName,
        department: userInformation.department===""?"":userInformation.department,
        designation: userInformation.designation===""?"":userInformation.designation,
        dob: userInformation.dob===""?"":userInformation.dob,
        doj: userInformation.doj===""?"":userInformation.doj,
        section: userInformation.section===""?"":userInformation.section,
        title: userInformation.title===""?"":userInformation.title,
        employeeStatus: userInformation.employeeStatus===""?"":userInformation.employeeStatus,
       }}
       onSubmit={(values, actions) => {
        const data = JSON.stringify(values, null, 2);
        console.log(data);

        axios.post(BASE_URL + "/api/register/InsertMissingEmployee", data)
                                .then(response => {
                                    if (response.status === 200) {
                                        primeToast.current.show({ 
                                            severity: 'success', 
                                            summary: 'Success', 
                                            detail: 'Information Added Successfully..!', 
                                            life: 3000 });

                                            setUserInformation({
                                                registerID: null,
                                                factoryID: "",
                                                employeeCode: "",
                                                employeeName: "",
                                                department:"",
                                                designation:"",
                                                dob:"",
                                                doj:"",
                                                section:"",
                                                title:"",
                                                employeeStatus:""
                                            });
                                            setIsEnable(true);
                                    }
                                    else{
                                        primeToast.current.show({
                                            severity: 'error',
                                            summary: 'Error',
                                            detail: 'Information Added Not Failed. Please Contact With MIS Team..!',
                                            life: 3000
                                        });
                                    }
                                }).catch(e => {
                                    primeToast.current.show({
                                        severity: 'error',
                                        summary: 'Error',
                                        detail: 'Information Added Error. Please Contact With MIS Team..!',
                                        life: 3000
                                    });
                                })
       
       }}
     >
       {props => (
         <form onSubmit={props.handleSubmit}>
          <div className="row">
            <div className="col-3">
                <TextField label={'Employee Code'} type="text" name="employeeCode"  
                onChange={props.handleChange} onBlur={props.handleBlur} 
                value={props.values.employeeCode} disabled placeholder="Employee Code.."/>         
            </div>
            <div className="col-3">
                <TextField label={'Employee Name'} type="text" name="employeeName" 
                onChange={props.handleChange} onBlur={props.handleBlur} 
                value={props.values.employeeName} disabled placeholder="Employee Name.."/>
            </div>
            <div className="col-3">
                <TextField label={'Department'} type="text" name="department"  
                onChange={props.handleChange} onBlur={props.handleBlur} 
                value={props.values.department} disabled placeholder="Employee Department.."/>
            </div>
            <div className="col-3">
                <TextField label={'Designation'} type="text" name="designation"  
                onChange={props.handleChange} onBlur={props.handleBlur} 
                value={props.values.designation} disabled placeholder="Employee Designation.."/>      
            </div>
          </div>
          <div className="row">
            <div className="col-3">
                <TextField label={'DOB'} type="text" name="dob"  
                onChange={props.handleChange} onBlur={props.handleBlur} 
                value={props.values.dob} disabled placeholder="Employee Date of Birth.."/>
            </div>
            <div className="col-3">
                <TextField label={'DOJ'} type="text" name="doj"
                onChange={props.handleChange} onBlur={props.handleBlur} 
                value={props.values.doj} disabled placeholder="Employee Date of Join.."/>      
            </div>
            <div className="col-3">
                <TextField label={'Section'} type="text" name="section"
                onChange={props.handleChange} onBlur={props.handleBlur} 
                value={props.values.section} disabled placeholder="Employee Section.."/>      
            </div>
            <div className="col-3">
                <TextField label={'Status'} type="text" name="title"
                onChange={props.handleChange} onBlur={props.handleBlur} 
                value={props.values.title+ " / " + props.values.employeeStatus} disabled placeholder="Employee New/Exists.."/>      
            </div>
          </div>
            <div className="row">
                <div className="col-12">
                
                {props.errors.name && <div id="feedback">{props.errors.name}</div>}
                    
                    <button type="submit" disabled={isEnable=== true? true : false} className="btn btn-primary"><i class="bi bi-check2-all"></i> Insert Employee</button>
                    <button disabled={isActivateEmployee === true? false : true} className="btn btn-success ms-2" onClick={ActivateUser}><i class="bi bi-person-plus-fill"></i> Activate Employee</button>
                    <button disabled={isRemove === true? false : true} className="btn btn-danger ms-2" onClick={DeactiveUser}><i class="bi bi-person-x-fill"></i> Deactivate Employee</button>
                </div>
            </div>
            <TextField label={''} type="hidden" name="registerID"  
            onChange={props.handleChange} 
            onBlur={props.handleBlur} value={props.values.registerID}/>
         </form>
       )}
            </Formik>
            </div>
        </div>

    </Layout>)
}

export default EmployeeInsert